import { Injectable } from '@angular/core';

@Injectable()
export default class QueueService {
  private queue: object = {
    default: <any>[]
  };

  constructor() {}

  public _startNext(queueName = 'default'): void {
    if (this.queue[queueName].length) {
      this.queue[queueName][0].promiseResolve();
    }
  }

  public add(id: number = null, promiseResolve: Function, queueName: string = 'default'): void {
    if (id === null) {
      console.error('Queue:add "No id parameter"');

      return;
    }

    if (!this.queue.hasOwnProperty(queueName)) {
      this.queue[queueName] = [];
    }

    this.queue[queueName].push({
      id,
      promiseResolve
    });

    if (this.queue[queueName].length === 1) {
      this._startNext(queueName);
    }
  }

  public remove(id: number = null, queueName: string = 'default'): void{
    if (id === null) {
      console.error('Queue:remove "No id parameter"');

      return;
    }

    if (!this.queue.hasOwnProperty(queueName)) {
      return;
    }

    if (this.queue[queueName].length) {
      this.queue[queueName].shift();
    }

    this._startNext(queueName);
  }
}


